import type { Tokens } from '../../../theming/types'
import type { ScrimProps } from '..'

export default (config: {
  props: Pick<ScrimProps, 'light'>
  tokens: Tokens
}) => {
  const { props, tokens } = config

  return {
    scrim: {
      backgroundColor: props.light
        ? tokens.bgColorDefault
        : tokens.bgColorScrim,
    },
  } as const
}
